import CircleSvg from 'assets/icons/CircleOutlined.svg?react';

import { createAntdIcon } from 'components/icons/createAntdIcon';

export default createAntdIcon(CircleSvg, { displayName: 'CircleOutlined' });
